import { ArrowRight, CheckCircle } from 'lucide-react';

export const HeroSection = ({ onCtaClick }) => {
  return (
    <section className="hero-bg noise-overlay min-h-screen flex items-center pt-24 md:pt-20" data-testid="hero-section">
      <div className="container-custom w-full py-12 md:py-0">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left content */}
          <div className="animate-fade-in-up">
            {/* H1 */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-[#1F2937] mb-6 tracking-tight">
              Professionell fönstermålning
              <span className="block text-[#2C3E50]">– bevara, skydda och förnya</span>
            </h1>

            {/* Description */}
            <p className="text-base md:text-lg text-[#64748B] mb-8 max-w-xl">
              Vi förlänger livslängden på dina fönster med noggrant förarbete och rätt teknik. 
              Få ett felfritt resultat som håller i många år – till fast pris och med ROT-avdrag.
            </p>

            {/* USPs */}
            <ul className="space-y-3 mb-10">
              {[
                'Erfaren målerifirma med tusentals genomförda projekt',
                'Noggrant förarbete – skrapning, slipning, grundning',
                'Fast pris – inga överraskningar',
              ].map((usp, index) => (
                <li key={index} className="flex items-start gap-3 text-[#1F2937]">
                  <div className="w-5 h-5 mt-0.5 rounded-full bg-[#C0392B] flex items-center justify-center flex-shrink-0">
                    <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="font-medium">{usp}</span>
                </li>
              ))}
            </ul>

            {/* CTA buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <button
                onClick={onCtaClick}
                className="btn-cta text-lg"
                data-testid="hero-cta-button"
              >
                Få kostnadsfri offert
                <ArrowRight className="w-5 h-5" />
              </button>
              <a
                href="tel:08-254604"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-[#2C3E50] text-[#2C3E50] font-medium hover:bg-[#2C3E50] hover:text-white transition-colors duration-200"
                data-testid="hero-phone-button"
              >
                Ring 08-25 46 04
              </a>
            </div>

            {/* Trust badges - nu under knapparna */}
            <div className="flex flex-wrap gap-4 pt-4 border-t border-[#E2E8F0]">
              <div className="flex items-center gap-2 text-[#64748B]" data-testid="trust-badge-experience">
                <CheckCircle className="w-5 h-5 text-[#C0392B]" />
                <span className="text-sm font-medium">30+ års erfarenhet</span>
              </div>
              <div className="flex items-center gap-2 text-[#64748B]" data-testid="trust-badge-response">
                <CheckCircle className="w-5 h-5 text-[#C0392B]" />
                <span className="text-sm font-medium">Svar inom 24h</span>
              </div>
              <div className="flex items-center gap-2 text-[#64748B]" data-testid="trust-badge-quality">
                <CheckCircle className="w-5 h-5 text-[#C0392B]" />
                <span className="text-sm font-medium">Tusentals nöjda kunder</span>
              </div>
            </div>
          </div>

          {/* Right - Image */}
          <div className="relative animate-slide-in-right delay-200 hidden lg:block">
            <div className="relative z-10 img-hover-zoom">
              <img
                src="https://images.unsplash.com/photo-1640362769928-bc6e09cf3bfc?w=800&h=600&fit=crop&q=80"
                alt="Professionell fönstermålning av erfarna målare i Stockholm"
                className="w-full h-auto shadow-xl"
                loading="eager"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#C0392B] z-0" aria-hidden="true" />
            <div className="absolute -top-6 -right-6 w-24 h-24 border-4 border-[#2C3E50] z-0" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
